<!-- content start -->
<div class="content-grey" [formGroup]="periodicReportForm">
  <div class="d-flex justify-content-center align-items-center">
    <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
  </div>

  <div class="row p-0" *ngIf="!loading">

    <div class="col-lg-12 col-md-6 col-12" *ngIf="report?.ou && mode !== 'create'">
      <div class="d-flex align-items-center">
        <div class="tab-profile">
          <img *ngIf="checkisImg(report.ou?.image); else elseBlock" src="{{ staticURL }}{{ report.ou?.image }}" class="tab-profile-img" style="max-height: 30px; max-width: 30px" />
          <ng-template #elseBlock>
            <i class="{{ report.ou?.image }} p-2" style="font-size: 1rem"></i>
          </ng-template>
        </div>
        <h5 class="">
          {{report?.ou?.name}}
        </h5>
      </div>
    </div> 


    <ng-container *ngIf="mode !== 'Manager' || hasPermission('PERIODIC_REPORTS', 'u')">
      <!-- Show OU dropdown only in create mode -->
      <ng-container *ngIf="mode === 'create'">
        <div class="col-lg-12 col-md-12 col-12">
          <div class="d-flex flex-column">
            <div class="d-flex my-2">
              <!-- <img class="filter-brightness" src="../../../../assets/icones-2025/apartment.png" alt="loading"> -->
              <i class="pi pi-building big-icone-color"></i>
              <label class="label-ui">{{'Ministry'|translator}}</label>
            </div>
            <div>
              <p-treeSelect class="v4-tree" containerStyleClass="v4-tree w-100" [selectionMode]="'multiple'"
              [metaKeySelection]="false" [disabled]="isManagerMode || mode !== 'create'"
                [options]="selectedTreeData" appendTo="body" formControlName="ou" (ngModelChange)="getContentUpdates()"
                placeholder="{{ 'Select the ministry' | translator }}" [filter]="true"
                [filterInputAutoFocus]="true">
                <ng-template let-node pTemplate="default">
                  <div class="d-flex">
                    <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}"
                      class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
                    <ng-template #elseBlock>
                      <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                    </ng-template>
                    <b class="text-nowrap">{{ node.label }}</b>
                  </div>
                </ng-template>
              </p-treeSelect>
              <small class="p-error" *ngIf="periodicReportForm.get('ou')?.invalid && periodicReportForm.get('ou')?.touched">
                {{ translate('Select the ministry') }}
              </small>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Show read-only OU display in other modes -->
      <ng-container *ngIf="mode !== 'create'">
        <!-- REMOVE THIS BLOCK: OU read-only display -->
      </ng-container>
      <div  *ngIf="mode !== 'create' && periodicReportForm.get('manager')?.value" class="col-lg-6 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <!-- <img class="filter-brightness" src="../../../../assets/icones-2025/person_2.png" alt="loading"> -->
            <i class="pi pi-user icone-color"></i>
            <label class="label-ui">{{"Expert" | translator}}</label>
          </div>
          <div>
            <div class="d-flex align-items-center">
              <div class="tab-grey-box-3">
                <div>{{periodicReportForm.get('manager')?.value?.name}}</div>
              </div>
              <!-- <div class="plus-btn ms-2" (click)="periodicReportForm.get('manager')?.setValue(null)">
                <i class="pi pi-times"></i>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <!-- <img class="filter-brightness" src="../../../../assets/icones-2025/calendar_today.png" alt="loading"> -->
             <i class="pi pi-calendar big-icone-color"></i>
            <label class="label-ui">{{"After Number of days" | translator}}</label>
          </div>
          <input type="number" id="days" formControlName="days"
           pInputText>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <!-- <img class="filter-brightness" src="../../../../assets/icones-2025/schedule.png" alt="loading"> -->
             <i class="pi pi-clock big-icone-color"></i>
            <label class="label-ui">{{"time" | translator}}</label>
          </div>
          <p-calendar class="ppp-calander" dir="ltr" [showIcon]="false" formControlName="time" [showTime]="true" [hourFormat]="'12'" [timeOnly]="true" [showSeconds]="false" [stepMinute]="60" ></p-calendar>
        </div>
      </div>

    </ng-container>
    
    <div class="col-lg-6 col-md-6 col-12">
      <div class="d-flex flex-column">
        <div class="d-flex my-2">
          <!-- <img class="filter-brightness" src="../../../../assets/icones-2025/calendar_today.png" alt="loading"> -->
           <i class="pi pi-calendar big-icone-color"></i>
          <label class="label-ui">{{"Next Report Date" | translator}}</label>
        </div>
        <div class="d-flex">
          <div class="tab-white-box">
            <div class="inner-data-border">
              <!-- <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="loading"> -->
               <i class="pi pi-calendar big-icone-color"></i>
              <div>{{ enhancedDate ? (enhancedDate | date:'MMM - dd -yyyy') : (currentDate | date:'MMM - dd -yyyy') }}</div>
            </div>
            <div class="inner-data">
              <!-- <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading"> -->
               <i class="pi pi-clock big-icone-color"></i>
              <div>{{ periodicReportForm.get('time')?.value ? (periodicReportForm.get('time')?.value | date:'shortTime') : (currentDate | date:'shortTime') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Start/End Date fields (create mode) -->
    <ng-container *ngIf="mode === 'create'">
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <!-- <img class="filter-brightness" src="../../../../assets/icones-2025/calendar_today.png" alt="loading"> -->
             <i class="pi pi-calendar big-icone-color"></i>
            <label class="label-ui">{{"Start Date" | translator}}</label>
          </div>
          <p-calendar class="ppp-calander"
            formControlName="startDate"
            [maxDate]="maxDate"
            [showIcon]="false"
            [showButtonBar]="true"
            [readonlyInput]="false"
            *ngIf="!isManagerMode"
            appendTo="body"
            [style]="{'width':'100%'}"
            [inputStyleClass]="'w-100'"
            [panelStyleClass]="'ppp-calender-panel'"
            placeholder="{{ 'Start Date' | translator }}"
            (onSelect)="onStartDateSelect($event)"
            (onClear)="onStartDateClear()"
            [class.ng-invalid]="periodicReportForm.get('startDate')?.invalid && periodicReportForm.get('startDate')?.touched"
            [class.ng-dirty]="periodicReportForm.get('startDate')?.dirty">
            <ng-template pTemplate="header">
              <div class="d-flex justify-content-between align-items-center p-2">
                <span class="text-lg font-bold">{{ translate('Select Date') }}</span>
              </div>
            </ng-template>
          </p-calendar>
        </div>
      </div>

      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <!-- <img class="filter-brightness" src="../../../../assets/icones-2025/calendar_today.png" alt="loading"> -->
             <i class="pi pi-calendar big-icone-color"></i>
            <label class="label-ui">{{"End Date" | translator}}</label>
          </div>
          <p-calendar class="ppp-calander" 
            formControlName="endDate"
            [maxDate]="maxDate"
            [minDate]="periodicReportForm.get('startDate')?.value"
            [showIcon]="false"
            [showButtonBar]="true"
            [readonlyInput]="false"
            *ngIf="!isManagerMode"
            appendTo="body"
            [style]="{'width':'100%'}"
            [inputStyleClass]="'w-100'"
            [panelStyleClass]="'ppp-calender-panel'"
            placeholder="{{ 'End Date' | translator }}"
            (onSelect)="onEndDateSelect($event)"
            (onClear)="onEndDateClear()"
            [class.ng-invalid]="periodicReportForm.get('endDate')?.invalid && periodicReportForm.get('endDate')?.touched"
            [class.ng-dirty]="periodicReportForm.get('endDate')?.dirty">
            <ng-template pTemplate="header">
              <div class="d-flex justify-content-between align-items-center p-2">
                <span class="text-lg font-bold">{{ translate('Select Date') }}</span>
              </div>
            </ng-template>
          </p-calendar>
          <small class="p-error" *ngIf="periodicReportForm.get('endDate')?.invalid && periodicReportForm.get('endDate')?.touched">
            {{ translate('End date cannot be greater than today') }}
          </small>
        </div>
      </div>
    </ng-container>

    <!-- <div class="row p-0"> -->
    <div *ngIf="mode !== 'create'" class="col-lg-6 col-md-6 col-12 d-flex align-items-end">
      <div class="d-flex flex-column w-100">
        <div class="d-flex my-2">
          <!-- <img class="filter-brightness" src="../../../../assets/icones-2025/calendar_today.png" alt="loading"> -->
           <i class="pi pi-calendar big-icone-color"></i>
          <label class="label-ui">{{"Report Form" | translator}}</label>
        </div>
        <div class="tab-grey-box-modal">
          <!-- <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="loading"> -->
           <i class="pi pi-calendar big-icone-color"></i>
          <div>{{report?.reportForm !== 'New Report form started' ? (report.reportForm | date:'dd-MM-yyyy') :
            report.reportForm | translator}}</div>
        </div>
      </div>
      <!-- <div class="col-lg-1 col-md-6 col-12 d-flex align-items-end"> -->
        <div class="tab-arrow mx-2 mb-4">
          <!-- <img class="tab-icone" src="../../../../assets/icones-2025/arrow_cool_down.png" alt="loading"> -->
           <i class="pi pi-arrow-left icone-white"></i>
        </div>
      <!-- </div> -->
        <!-- <div class="col-lg-2 col-md-6 col-12 d-flex align-items-end"></div> -->
         <div class="d-flex flex-column w-100">
        <div class="d-flex my-2">
          <!-- <img class="filter-brightness" src="../../../../assets/icones-2025/calendar_today.png" alt="loading"> -->
           <i class="pi pi-calendar big-icone-color"></i>
          <label class="label-ui">{{"Report To" | translator}}</label>
        </div>
        <div class="tab-grey-box-modal">
          <!-- <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="loading"> -->
           <i class="pi pi-calendar big-icone-color"></i>
          <div>{{report?.reportTo | date:'dd-MM-yyyy'}}</div>
        </div>
      </div>
      <!-- </div> -->
    <!-- </div> -->

  </div>
  <div class="content-white" *ngIf="!loading && contentUpdateData.length > 0" >
    <ng-container *ngFor="let type of contentUpdateData">
    <div class="d-flex align-items-center my-3">
      <div class="d-flex">
        <div class="plus-btn">
          <img class="" src="../../../../assets/icones-2025/add.png" alt="loading">
        </div>
      </div>
      <div class="d-flex">
        <p class="text">{{ type.type !== 'OU CHANGE' ? 'تم ' + (type.type | translator) : (type.type | translator)}}</p>
      </div>
      <div class="custom-hr"></div>
    </div>
    <div  class="d-flex flex-wrap" *ngIf="type.data?.length > 0; else noTypeDataGlobal">
      <div *ngFor="let item of type.data" class="blue-num-btn" >
        <div class="d-flex">
          <div class="btn-num">
            {{ item.count }}
          </div>
        </div>
        <div class="d-flex align-items-center mx-2">
          <img class="" src="../../../../assets/icones-2025/draft.png" alt="loading">
        </div>
        <div class="d-flex">
          <label class="cursor">{{ item._id | translator}}</label>
        </div>
      </div>
    </div>
    <ng-template #noTypeDataGlobal>
      <div class="text-center p-2 w-100">{{'no data here' | translator}}</div>
    </ng-template>
  </ng-container>
  </div>

  


<!-- Display data for each selected OU -->
<div class="content-white mt-4" *ngIf="!loading && selectedOUsData.length > 0">
  <div *ngFor="let ouData of selectedOUsData" class="mb-4">
    <div class="d-flex align-items-center mb-3">
      <div class="tab-profile">
        <img *ngIf="checkisImg(ouData.ou?.image); else elseBlock" 
             src="{{ staticURL }}{{ ouData.ou?.image }}" 
             class="tab-profile-img" 
             style="max-height: 30px; max-width: 30px" />
        <ng-template #elseBlock>
          <i class="{{ ouData.ou?.image }} p-2" style="font-size: 1rem"></i>
        </ng-template>
      </div>
      <h5 class="mb-0">{{ ouData.ou?.label }}</h5>
    </div>

    <!-- Manager selection for each OU (only in create mode) -->
    <div *ngIf="mode === 'create'" class="mb-3">
      <div class="d-flex align-items-center">
        <!-- <img class="filter-brightness me-2" src="../../../../assets/icones-2025/person_2.png" alt="loading"> -->
        <i class="pi pi-user icone-color"></i>
        <label class="label-ui me-2">{{'Expert'| translator}}</label>
        <ng-container *ngIf="ouData.managers && ouData.managers.length > 0; else noManagerBlock">
          <p-dropdown class="ppp-dropdown-2"
            [options]="ouData.managers" 
            optionLabel="name" 
            optionValue="_id"
            [ngModel]="ouData.selectedManager?._id"
            [ngModelOptions]="{ standalone: true }"
            [filter]="ouData.managers.length > 5"
            filterBy="name,email"
            (onChange)="onManagerSelect(ouData.ou._id, getManagerById(ouData.managers, $event.value))"
            placeholder="{{ 'Select manager' | translator }}">
            <ng-template let-manager pTemplate="item">
              <div class="d-flex flex-column">
                <span>{{ manager.name }}</span>
                <small class="">{{ manager.email }}</small>
              </div>
            </ng-template>
          </p-dropdown>
        </ng-container>
        <ng-template #noManagerBlock>
          <span class="text-danger ms-2" *ngIf="ouData.managersError">{{ 'Could not load report experts' | translator }}</span>
          <span class="text-danger ms-2" *ngIf="!ouData.managersError">{{ 'No report experts are assigned to this unit' | translator }}</span>
          <a *ngIf="!ouData.managersError && hasPermission('CONTENT_EXPERTS_MANAGEMENT','c')" class="ms-2 cursor text-decoration-underline"
            routerLink="/content-experts" (click)="closeModal.emit(false)">{{ 'Manage experts' | translator }}</a>
        </ng-template>
      </div>
    </div>

    <div *ngIf="hasAnyContentData(ouData.contentUpdates); else noUpdatesForOU">
      <ng-container *ngFor="let type of ouData.contentUpdates">
        <div class="d-flex align-items-center my-3">
          <div class="d-flex">
            <div class="plus-btn">
              <img src="../../../../assets/icones-2025/edit.png" alt="loading">
            </div>
          </div>
          <div class="d-flex">
            <p class="text">{{ type.type !== 'OU CHANGE' ?  (type.type | translator) : (type.type | translator)}}</p>
          </div>
          <div class="custom-hr"></div>
        </div>
        <div class="d-flex flex-wrap" *ngIf="type.data?.length > 0; else noTypeDataOU">
          <div *ngFor="let item of type.data" class="blue-num-btn">
            <div class="d-flex">
              <div class="btn-num">
                {{ item.count }}
              </div>
            </div>
            <div class="d-flex align-items-center mx-2">
              <img src="../../../../assets/icones-2025/draft.png" alt="loading">
            </div>
            <div class="d-flex">
              <label class="cursor">{{ item._id | translator}}</label>
            </div>
          </div>
        </div>
        <ng-template #noTypeDataOU>
          <div class="text-center p-2 w-100">{{'There is no data' | translator}}</div>
        </ng-template>
      </ng-container>
    </div>

    <!-- Show a single, clear message when all sections for this OU are empty -->
    <ng-template #noUpdatesForOU>
      <div class="text-center p-4">
        <i class="pi pi-info-circle text-blue-500 mr-2"></i>
        {{ 'No knowledge portal updates during the selected period' | translator }}
      </div>
    </ng-template>
  </div>
</div>
<!-- content end -->

<ng-container *ngIf="((status !== 'PENDING' || mode == 'Manager') && mode !== 'create') && !loading">
  <div class="content-white">
    <p class="text-300">{{'Have all the organization data been reviewed on the knowledge portal?'|translator}}</p>
    <div class="d-flex">
      <div [class]="periodicReportForm.get('confirmation')?.value === true ? 'yes-btn active' : 'btn-defualt'" (click)="report.status !== 'SIGNED' ? periodicReportForm.patchValue({confirmation: true}) : null">
        <div class="d-flex">
          <label class="cursor">{{'Yes'|translator}}</label>
        </div>
      </div>
      <div [class]="periodicReportForm.get('confirmation')?.value === false ? 'no-btn active' : 'btn-defualt'" (click)="report.status !== 'SIGNED' ? periodicReportForm.patchValue({confirmation: false}) : null">
        <div class="d-flex">
          <label class="cursor">{{'No'|translator}}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="content-white">
    <p class="text-300">{{'Please add comments'|translator}}</p>
    <div class="form-floating">
      <textarea class="form-control custom-textarea" formControlName="comment" placeholder="{{'Leave a comment here' | translator}}" id="floatingTextarea2"
        style="height: 100px"></textarea>
    </div>
  </div>
  <div class="content-white">
    <p class="text-300">{{'Please confirm'|translator}}</p>
    <div class="text-radio-bar">
      <div class="d-flex">
        <input class="form-check-input" type="checkbox" formControlName="agreement" name="agreement">
      </div>
      <span class="text-white">{{'I agree to the terms and conditions'|translator}}</span>
    </div>
  </div>
</ng-container>


<div class="d-flex" *ngIf="!loading">
  <div class="submit-blue-btn" (click)="submitForm()" [style.opacity]="submitting ? 0.6 : 1" [style.pointer-events]="submitting ? 'none' : 'auto'" [attr.aria-busy]="submitting">
    <div class="d-flex align-items-center">
      <i *ngIf="submitting" class="pi pi-spin pi-spinner"></i>
      <img *ngIf="!submitting" class="" src="../../../../assets/icones-2025/check_small.png" alt="loading">
    </div>
    {{ (report?.status !== 'SIGNED' ? 'Submit' : 'Close') | translator}}
  </div>
</div>


</div>